// extracted by mini-css-extract-plugin
export var footer = "styles-module--footer--wDw1j";
export var center = "styles-module--center--6L6aA";
export var copyright = "styles-module--copyright--8SKt6";